import { render, staticRenderFns } from "./TdAdditionalPayRemitter.vue?vue&type=template&id=c05cd770&"
import script from "./TdAdditionalPayRemitter.vue?vue&type=script&lang=ts&"
export * from "./TdAdditionalPayRemitter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports